const CustomWishlist = {
  storageKey: 'label-shopper-wishlist-v1',

  getItems() {
    try {
      const items = JSON.parse(
        localStorage.getItem(this.storageKey) || '[]'
      );

      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  },

  saveItems(items) {
    localStorage.setItem(
      this.storageKey,
      JSON.stringify(items)
    );

    this.refresh();
  },

  toggleProduct(button) {
    const product = {
      id: String(button.dataset.wishlistProductId || ''),
      title: button.dataset.wishlistTitle || '',
      url: button.dataset.wishlistUrl || '',
      image: button.dataset.wishlistImage || '',
      price: button.dataset.wishlistPrice || '',
      variantId: String(button.dataset.wishlistVariantId || ''),
      available: button.dataset.wishlistAvailable === 'true'
    };

    if (!product.id) return;

    const items = this.getItems();

    const existingIndex = items.findIndex(
      item => String(item.id) === product.id
    );

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    } else {
      items.unshift(product);
    }

    this.saveItems(items);
  },

  removeProduct(productId) {
    const items = this.getItems().filter(
      item => String(item.id) !== String(productId)
    );

    this.saveItems(items);
  },

  updateButtons() {
    const savedProductIds = new Set(
      this.getItems().map(item => String(item.id))
    );

    document
      .querySelectorAll('[data-wishlist-toggle]')
      .forEach(button => {
        const productId = String(
          button.dataset.wishlistProductId || ''
        );

        const isActive = savedProductIds.has(productId);

        button.classList.toggle('is-active', isActive);

        button.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );

        const label = button.querySelector(
          '[data-wishlist-button-label]'
        );

        if (label) {
          label.textContent = isActive
            ? 'Remove from Wishlist'
            : 'Add to Wishlist';
        }
      });
  },

  updateCount() {
    const count = this.getItems().length;

    document
      .querySelectorAll('[data-wishlist-count]')
      .forEach(element => {
        element.textContent = String(count);
      });
  },

  escapeHTML(value) {
    const element = document.createElement('div');
    element.textContent = value || '';

    return element.innerHTML;
  },

  renderWishlistPage() {
    const wishlistPage = document.querySelector(
      '[data-wishlist-page]'
    );

    if (!wishlistPage) return;

    const grid = wishlistPage.querySelector(
      '[data-wishlist-grid]'
    );

    const emptyMessage = wishlistPage.querySelector(
      '[data-wishlist-empty]'
    );

    if (!grid || !emptyMessage) return;

    const items = this.getItems();

    if (items.length === 0) {
      grid.innerHTML = '';
      emptyMessage.hidden = false;
      return;
    }

    emptyMessage.hidden = true;

    grid.innerHTML = items.map(item => {
      const productId = this.escapeHTML(item.id);
      const title = this.escapeHTML(item.title);
      const url = this.escapeHTML(item.url);
      const image = this.escapeHTML(item.image);
      const price = this.escapeHTML(
        String(item.price || '').replace(/\s*[A-Z]{3}\s*$/, '')
      );
      const variantId = this.escapeHTML(item.variantId);

      const imageMarkup = image
        ? `
          <img
            class="custom-wishlist-card__image"
            src="${image}"
            alt="${title}"
            loading="lazy"
            width="600"
            height="750"
          >
        `
        : `
          <div class="custom-wishlist-card__placeholder"></div>
        `;

      const cartMarkup =
        item.available && variantId
          ? `
            <button
              type="button"
              class="button custom-wishlist-card__cart"
              data-wishlist-add-cart
              data-variant-id="${variantId}"
            >
              Add to cart
            </button>
          `
          : `
            <span class="custom-wishlist-card__sold-out">
              Sold out
            </span>
          `;

      return `
        <article
          class="custom-wishlist-card"
          data-wishlist-item="${productId}"
        >
          <a
            class="custom-wishlist-card__image-link"
            href="${url}"
          >
            ${imageMarkup}
          </a>

          <button
            type="button"
            class="custom-wishlist-card__heart"
            data-wishlist-remove="${productId}"
            aria-label="Remove ${title} from wishlist"
            title="Remove from wishlist"
          >
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
              <path d="M12 20.5s-7.5-4.6-9.3-9.1C1.4 8.1 3.4 4.5 7 4.5c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.6 0 5.6 3.6 4.3 6.9-1.8 4.5-9.3 9.1-9.3 9.1z" fill="currentColor"/>
            </svg>
          </button>

          <div class="custom-wishlist-card__details">
            <a
              class="custom-wishlist-card__title"
              href="${url}"
            >
              ${title}
            </a>

            <p class="custom-wishlist-card__price">
              ${price}
            </p>

            <div class="custom-wishlist-card__actions">
              ${cartMarkup}
            </div>
          </div>
        </article>
      `;
    }).join('');
  },

  async addToCart(button) {
    const variantId = button.dataset.variantId;

    if (!variantId || button.disabled) return;

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const shopRoot =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(
        `${shopRoot}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {
        throw new Error('Product could not be added');
      }

      button.textContent = 'Added';

      // Added to cart: take the product off the wishlist
      const addedCard = button.closest('[data-wishlist-item]');
      const addedId = addedCard ? addedCard.dataset.wishlistItem : '';

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      setTimeout(() => {
        if (addedId) {
          this.removeProduct(addedId);
        } else {
          button.textContent = originalText;
          button.disabled = false;
        }
      }, 900);
    } catch (error) {
      button.textContent = 'Try again';

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1600);
    }
  },

  refresh() {
    this.updateButtons();
    this.updateCount();
    this.renderWishlistPage();
  },

  init() {
    document.addEventListener('click', event => {
      const wishlistButton = event.target.closest(
        '[data-wishlist-toggle]'
      );

      if (wishlistButton) {
        event.preventDefault();
        event.stopPropagation();

        this.toggleProduct(wishlistButton);
        return;
      }

      const removeButton = event.target.closest(
        '[data-wishlist-remove]'
      );

      if (removeButton) {
        event.preventDefault();

        this.removeProduct(
          removeButton.dataset.wishlistRemove
        );

        return;
      }

      const addToCartButton = event.target.closest(
        '[data-wishlist-add-cart]'
      );

      if (addToCartButton) {
        event.preventDefault();
        this.addToCart(addToCartButton);
      }
    });

    window.addEventListener('storage', () => {
      this.refresh();
    });

    document.addEventListener(
      'shopify:section:load',
      () => {
        this.refresh();
      }
    );

    this.refresh();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => CustomWishlist.init(),
    { once: true }
  );
} else {
  CustomWishlist.init();
}